import { useSyncExternalStore } from "react"
import { buildPlan, type Candidate, type Plan, seedPlans } from "./plans"

let plans: Plan[] = seedPlans()

const listeners = new Set<() => void>()

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

function publish(next: Plan[]): void {
  plans = next
  for (const listener of listeners) listener()
}

export function usePlans(): Plan[] {
  return useSyncExternalStore(subscribe, () => plans)
}

export function usePlan(planId: string): Plan | undefined {
  return usePlans().find((plan) => plan.id === planId)
}

export function findPlan(planId: string): Plan | undefined {
  return plans.find((plan) => plan.id === planId)
}

export function updatePlan(planId: string, change: (plan: Plan) => Plan): void {
  publish(plans.map((plan) => (plan.id === planId ? change(plan) : plan)))
}

export function createPlan(
  candidate: Candidate,
  sourceKind: Plan["sourceKind"],
  start: number,
): Plan {
  const plan = buildPlan(
    {
      id: `PLN-${String(plans.length + 1).padStart(3, "0")}`,
      tail: candidate.tail,
      model: candidate.model,
      title: candidate.title,
      source: candidate.source,
      sourceKind,
      status: "draft",
      owner: "You",
    },
    start,
  )
  publish([...plans, plan])
  return plan
}
